<template>
  <v-app
    id="knapp"
    :style="{ background: $vuetify.theme.themes[theme].background }"
  >
    <transition :name="transitionName" mode="out-in">
      <div v-if="$store.state.currentUser && $route.name != 'login'">
        <!-- NAVIGATION & TOP BAR -->
        <navbar></navbar>

        <!-- CONTENT -->
        <v-main>
          <v-container
            v-if="!$store.state.pageIsLoading"
            fluid
            class="pt-4 px-6"
          >
    
            <div>
              <h2
                class="mt-4 mb-2 title1"
                v-if="$route.meta && $route.meta.pageTitle"
              >
                <template v-if="!$route.params.id">
                  <template v-if="$route.meta.pageType === 'derivation_rules'">
                  <div class="row">
                    <div class="col">
                      <page-title :value="$t($route.meta.pageTitle)"/>
                    </div>
                    <div class="col text-right">
                      <help-text-btn name="CALCULATION_OVERVIEW"/>
                    </div>
                  </div>
                  </template>
                  <template v-else-if="$route.meta.pageType === 'ITEMS'">
                    <page-title :value="$t('ARTICLES-HEADING')"/>
                  </template>
                  <template v-else>
                  <page-title :value="$t($route.meta.pageTitle)"/>
                  </template>
                </template>
                <template v-else>
                  <template v-if="$route.meta.pageType === 'WAREHOUSE'">
                    <div
                      @mouseover="showWarehouseEditIcon = true"
                      @mouseleave="showWarehouseEditIcon = false"
                      class="title1"
                    >
                      <template
                        v-if="warehouseMandate && warehouseMandate.length > 0"
                        >{{ warehouseMandate }} -
                      </template>
                      <template v-if="!editWarehouseTitle">
                        {{ warehouseTitle }}
                      </template>
                      <template v-else>
                        <v-text-field
                          v-model="warehouseTitle"
                          append-outer-icon="mdi-content-save"
                          @click:append-outer="updateWarehouseTitle"
                          style="max-width: 300px; display: inline-flex;"
                        />
                        <v-icon
                          class=" pl-1"
                          @click="initWarehouseTitle"
                          color="grey darken-3"
                          >mdi-close</v-icon
                        >
                      </template>
                      <v-icon
                        v-if="warehouseEditIconVisible"
                        class="pb-1 pl-1"
                        @click="editWarehouseTitle = true"
                        color="grey darken-3"
                        >mdi-pencil</v-icon
                      >
                    </div>
                  </template>

                  <template v-else>
                    <page-title :value="$t($route.meta.pageTitle)"/>
                  </template>
                </template>
              </h2>

              <router-view></router-view>
            </div>

            <!-- </transition>-->
          </v-container>
        </v-main>
      </div>

      <template v-else>
        <v-main>
          <router-view></router-view>
        </v-main>
      </template>
    </transition>

    <!-- OVERLAY LOADER -->
    <v-overlay
      :opacity="0.75"
      color="white"
      :z-index="999999"
      :value="$store.state.pageIsLoading"
    >
      <v-progress-circular
        indeterminate
        size="64"
        color="grey darken-5"
      ></v-progress-circular>
    </v-overlay>

    <!-- SNACKBARS -->
    <v-snackbar
      v-for="(snackbar, index) in snackbars.filter((s) => s.showing)"
      :key="snackbar.text + Math.random()"
      v-model="snackbar.showing"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      top
      right
      :style="`top: ${index * 60 + 6}px`"
    >
      <v-icon left small v-if="snackbar.icon">{{ snackbar.icon }}</v-icon>

      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn icon @click="snackbar.showing = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <!-- MODAL LANGUAGE -->
    <modal-language :show="$store.getters.showModalLanguage"></modal-language>
  </v-app>
</template>

<script>
import navbar from "@/components/TheNavigation";
import modalLanguage from "@/components/modalLanguage";
import { mapState } from "vuex";
import HelpTextBtn from "./components/HelpTextBtn.vue";
import PageTitle from "./components/PageTitle.vue";
export default {
  name: "app",

  components: {
    navbar,
    modalLanguage,
    HelpTextBtn,
    PageTitle
  },

  data: () => ({
    showWarehouseEditIcon: false,
    editWarehouseTitle: false,
    warehouseTitle: "",
    warehouseMandate: "",

  }),

  computed: {
    ...mapState(["currentUser", "snackbars"]),

    warehouseEditIconVisible() {
      return (
        this.$route.meta.pageType === "WAREHOUSE" &&
        this.showWarehouseEditIcon &&
        !this.editWarehouseTitle
      );
    },

    transitionName() {
      if (this.$route.meta && this.$route.meta.transition) {
        return this.$route.meta.transition;
      }

      return "page-fade";
    },

    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

  created() {},

  mounted() {},

  updated() {},

  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        document.title =
          this.$t(to.meta.pageTitle) + " | KNAPP " || "KNAPP Cockpit";
        this.initWarehouseTitle();
      },
    },
  },

  methods: {

    initWarehouseTitle() {
      this.warehouseTitle = this.$route.meta.pageTitle;
      this.warehouseMandate = this.$route.meta.mandate;
      this.editWarehouseTitle = false;
      this.showWarehouseEditIcon = false;
    },
    updateWarehouseTitle() {
      this.axios
        .put("warehouses/" + this.$route.params.id, {
          name: this.warehouseTitle,
        })
        .then((res) => {
          this.$store.dispatch("setSnackbar", {
            text: this.$t("GLOBAL-MESSAGE-SUCCESSFULLY_SAVED"),
          });
          this.$route.meta.pageTitle = this.warehouseTitle;
          this.initWarehouseTitle();
        })
        .catch((err) => {
          this.$store.dispatch("setSnackbar", {
            text: this.$t("GLOBAL-MESSAGE-ERROR"),
            type: "error",
          });
        });
    },
  },
};
</script>

<style lang="sass">
@import '../node_modules/typeface-roboto/index.css'
</style>

<style lang="scss" src="@/assets/styles/main.scss"></style>

<style lang="scss">
.pageHeading {
  font-size: 26px;
  font-weight: normal;
}
</style>
